import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import preventDefault from 'shared/utils/preventDefault';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { Autocomplete, Button } from 'shared/components';
import LanguageSelector from 'modules/language/components/LanguageSelector';

import theme from './OrganizationSelectionForm.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  organizations: PropTypes.object.isRequired,
  organizationsOptions: PropTypes.array.isRequired,
  selectedOrganization: PropTypes.object,
  selectOrganizationToken: PropTypes.func.isRequired,
  handleOrganizationSelectionFocus: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
};

const defaultProps = { selectedOrganization: null };

const OrganizationSelectionForm = ({
  intl,
  organizations,
  organizationsOptions,
  selectedOrganization,
  selectOrganizationToken,
  handleOrganizationSelectionFocus,
  submitForm,
}) => {
  const { status, fetchTermsAndConditionsStatus, hasError } = organizations;
  const { pending: _pending, failure } = requestsStatuses;
  const pending = status === _pending || fetchTermsAndConditionsStatus === _pending;

  return (
    <div className={ theme.root }>
      <h2 className={ theme.title }>
        <FormattedMessage
          id="Authentication.OrganizationPicker.Label.ChooseOrganization"
          defaultMessage="** Please choose organization"
        />
      </h2>

      <form
        className={ theme.form }
        onSubmit={ preventDefault(submitForm) }
      >
        <Autocomplete
          testId="select-organization-autocomplete"
          menuClassName={ organizationsOptions.length === 0 ? theme.menu : '' }
          selectedItem={ selectedOrganization }
          items={ organizationsOptions }
          placeholder={{
            id: 'Authentication.OrganizationPicker.Labels.DropdownChooseOrganization',
            defaultMessage: '** Choose organization',
          }}
          noResultMessage={ organizationsOptions.length === 0
            ? {
              id: 'Authentication.OrganizationPicker.Error.CouldNotFetchOrgs',
              defaultMessage: '** Could not fetch organizations. Please try again',
            }
            : {
              id: 'General.NoResults',
              defaultMessage: 'No results found',
            }
          }
          disabled={ pending }
          iconName="organization"
          size="large"
          status={ hasError || status === failure ? failure : status }
          onChange={ (item) => selectOrganizationToken(item ? item.key : null) }
          onFocus={ handleOrganizationSelectionFocus }
          required
        />
        <Button
          testId="select-organization-button"
          label={ intl.formatMessage({ id: 'General.Next', defaultMessage: '** Next' }) }
          isLoading={ pending }
          iconName="arrow-right"
          size="large"
          disabled={ pending }
          mediaResized
          fullWidth
        />
      </form>
      <div className={ theme.footerContainer }>
        <LanguageSelector disabled={ pending } />
      </div>
    </div>
  );
};

OrganizationSelectionForm.propTypes = propTypes;
OrganizationSelectionForm.defaultProps = defaultProps;

export default OrganizationSelectionForm;
